import React from 'react'
import { useBoxSelect, UseBoxSelectOptions } from './useBoxSelect'
import styles from './BoxSelect.module.scss'

/** BoxSelect 组件 props · 完全复用 useBoxSelect 的配置，字段含义见 UseBoxSelectOptions */
export type BoxSelectProps = UseBoxSelectOptions

/**
 * 鼠标框选包裹组件 · 很薄的一层：调用 useBoxSelect + 渲染框选可视化矩形。
 *
 * 用法：放在"框选作用容器"内部，把该容器的 ref 与可选项属性名传入。
 * 组件本身只渲染一个常驻的矩形节点（默认 display:none，框选时由 hook 命令式显隐）。
 *
 * @example
 * ```tsx
 * <div ref={containerRef}>
 *   {items}
 *   <BoxSelect
 *     containerRef={containerRef}
 *     itemAttr="data-folder-id"
 *     onSelect={(ids) => setSelected(ids)}
 *   />
 * </div>
 * ```
 */
const BoxSelect: React.FC<BoxSelectProps> = (props) => {
  const rectRef = useBoxSelect(props)
  return <div ref={rectRef} className={styles.boxSelectRect} />
}

export default BoxSelect
